module.exports = __webpack_public_path__ + "media/asset/images/noChat-a91bfb254c95c9b9627586c7a8742b62.png";